import React, { useState } from 'react';
import { useAppContext } from '../../../../Services/AppContext';
import { Theme } from '../../../../Enums/Theme.enum';
import MediaViewerModal from '../../../../Components/MediaViewer/MediaViewerModal';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import { Document } from '../../../../graphql/graphql';
import styles from './MedicalRequestsListItem.module.scss';
import { prepareDocumentationFileForMediaViewer } from '../../../Ecard/Services/eCardFile.service';
import FileSignedBadge from '../../../Base/Components/FileSignedBadge/FileSignedBadge';
import useScope from '../../../Scope/Hooks/useScope';
import P1MedicalRequestCancelModal from '../../../P1/Components/P1MedicalRequestCancel/P1MedicalRequestCancelModal';
import LinkButton from '../../../../Components/Button/LinkButton';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	item: Document;
	onDelete: () => void;
}

const MedicalRequestsListItem: React.FC<Props> = ({ item, onDelete }) => {
	const [isMediaViewerOpened, setIsMediaViewerOpened] = useState(false);
	const { socketUrl } = useAppContext();
	const { isPoland } = useScope();
	const [isCancelOpen, setIsCancelOpen] = useState(false);

	const cancelationNote = item.items?.find(i => i?.type === 'cancelationNote')
		?.extra.text;

	const handleOnDelete = () => {
		setIsCancelOpen(false);
		onDelete();
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.date}>
				<FormattedMomentDate
					date={item.createdAt}
					format={DateFormat.DATE_TIME}
				/>
			</div>
			<div className={styles.content}>
				<div className={styles.title}>{item.title?.extra?.text}</div>
				{cancelationNote && (
					<div className={styles.cancelInfo}>
						<Text tx='base.shared.note' colon />
						{cancelationNote}
					</div>
				)}
			</div>
			<div className={styles.controls}>
				{item.documentationFile?.file?.signed && <FileSignedBadge />}
				{isPoland && item.isCancelable && (
					<LinkButton
						title='base.shared.cancel'
						theme={Theme.RED}
						onClick={() => setIsCancelOpen(true)}
						firstUpper
					/>
				)}
				{item.documentationFile && (
					<LinkButton
						onClick={() => setIsMediaViewerOpened(true)}
						title='base.show'
						theme={Theme.BLUE}
						firstUpper
					/>
				)}
			</div>
			{isMediaViewerOpened && item.documentationFile && (
				<MediaViewerModal
					opened
					onClose={() => setIsMediaViewerOpened(false)}
					file={prepareDocumentationFileForMediaViewer(
						item.documentationFile,
						socketUrl,
					)}
					isSignable={item.documentationFile.canBeSigned || false}
				/>
			)}
			{isCancelOpen && (
				<P1MedicalRequestCancelModal
					isOpen
					item={item}
					onClose={() => setIsCancelOpen(false)}
					onSuccess={handleOnDelete}
				/>
			)}
		</div>
	);
};

export default MedicalRequestsListItem;
